<template>
  <div class="Sidebar">
    <SidebarSide
      v-if="screenSizes.includes('sm')"
      v-bind="$attrs"
      :activeIndex.sync="activeIndex"
      :links="links"
      v-on="$listeners" />
    <SidebarBurger
      v-else
      v-bind="$attrs"
      :activeIndex.sync="activeIndex"
      :links="links"
      v-on="$listeners" />
  </div>
</template>

<script>
import SidebarBurger from './SidebarBurger'
import SidebarSide from './SidebarSide'
import { getters } from '@utils'
import { pluck } from 'rambda'

export default {
  components: {
    SidebarBurger,
    SidebarSide,
  },
  props: {
    links: { type: Array, default: () => [] },
  },
  data() {
    return {
      activeIndex: null,
    }
  },
  computed: getters('screenSizes'),
  methods: {
    determineActiveIndex() {
      this.activeIndex = this.links.findIndex(({ to, children = [] }) => {
        const routeName = typeof to === 'object' ? to.name : to
        const matchedRouteNames = [...pluck('to', children), routeName]
        return this.$route.matched
          .find(({ name }) => matchedRouteNames.includes(name))
      })
    },
  },
  created() {
    this.determineActiveIndex()
  },
}
</script>

<style lang="scss">
$_background: $main-darker;
// $_background-children: $main-light;

.Sidebar {
  position: relative;
  z-index: 1;

  .SidebarSide,
  .SidebarBurger,
  .SidebarBurger nav {
    background: $_background;
  }
}
</style>
